import { Divider as MantineDivider, DividerProps } from '@mantine/core';

export type IDividerProps = DividerProps;

/** @registry Design-layer pass-through over Mantine Divider; import this instead of @mantine/core Divider outside src/design. */
export const Divider = MantineDivider;
